import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import SubHeader from "../../components/SubHeader";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import MyRecivedInquiry from "../admin/MyRecivedInquiry";
import MySendInquiry from "../admin/MySendInquiry";
import { MENU_ROUTES } from "../../config/menuRoutes";
import { useAuth } from "../../AuthProvider";
const MyInquiries = (props) => {
  const [key, setKey] = useState('Received Inquiry');
  const nav = useNavigate();
  const { isSuperAdmin, user, isEndUser, isDemoUser } = useAuth();
  useEffect(() => {
    if (!isEndUser && (user && isDemoUser)) {
      nav(MENU_ROUTES.ALL_INQUIRIES);
    }
    if (isSuperAdmin) {
      nav(MENU_ROUTES.ALL_INQUIRIES);
    }
    if (user && user.trade_mode_type === "BUYER") {
      setKey("Sent Inquiry");
    }
  }, [isEndUser, user, isSuperAdmin, key]);

  return (
    <div className="data-table-main">
      <SubHeader
        layer1="My Inquiries"
        layer2=""
        layer3="List"
        pageName="My Inquiries"
        clickable={{
          layer1: "",
          layer2: "",
          layer3: "",
        }}
      />

      <div className="send-receive-inquiry">

        <Tab.Container id="left-tabs-example" activeKey={key} onSelect={(k) => setKey(k)}>
          <Row>
            <Col sm={12} className="tab-menu">
              <div className="tab-menu-child">
                <Nav variant="pills">

                  <Nav.Item>
                    <Nav.Link eventKey="Sent Inquiry" className="d-flex">
                      <p className="px-2 profile-tab ">Sent Inquiry</p>
                    </Nav.Link>
                  </Nav.Item>

                  {user && user.trade_mode_type !== 'BUYER' && (
                    <Nav.Item>
                      <Nav.Link eventKey="Received Inquiry" className="d-flex">
                        <p className="px-2 profile-tab">Received Inquiry</p>
                      </Nav.Link>
                    </Nav.Item>
                  )}
                </Nav>
              </div>
            </Col>

            <Col sm={12}>
              <Tab.Content>
                <Tab.Pane eventKey="Sent Inquiry">
                  <MySendInquiry type="SEND" />
                </Tab.Pane>

                <Tab.Pane eventKey="Received Inquiry">
                  <MyRecivedInquiry type="RECEIVED" />
                </Tab.Pane>

              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>

      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(MyInquiries);
